import React from 'react';
import { motion } from 'framer-motion';
export const CHECKOUT_URL = 'https://gemoterapia.impultienda.ar/checkout/front';
export const PRODUCT_NAME = 'MEGA PACK MAESTRO DE GEMOTERAPIA™';
export const PRICE = '$25.990 ARS';
export const PRICE_SHORT = '$25.990';
export const PRICE_FULL = '$110.000 ARS';
export const SUPPORT_EMAIL = 'soportelumenakasha@gmail.com';
export const WHATSAPP_LINK = 'https://wa.me/541153399780';
export const INSTAGRAM_LINK = 'https://instagram.com/lumen.akasha';
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
  glow?: boolean;
};
export function Section({
  children,
  className = '',
  id = '',
  glow = false
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.55
  }} className={`relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-251" data-mp="pexsh7vn7k7v">
      {glow && <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" data-id="element-252" data-mp="39jhj4z18n9yz">
          <div className="animate-aurora-1 absolute -top-16 left-[15%] h-80 w-80 rounded-full bg-brand-purpleMist blur-[100px]" data-id="element-253" data-mp="34lpnpv1dx5q1" />
          <div className="animate-aurora-2 absolute -bottom-12 right-[12%] h-72 w-72 rounded-full bg-brand-goldLight/60 blur-[110px]" data-id="element-254" data-mp="2vk8b4mn6rm63" />
        </div>}
      {children}
    </motion.section>;
}
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'purple' | 'gold';
};
export function CTAButton({
  children,
  href = CHECKOUT_URL,
  className = '',
  fullWidth = false,
  variant = 'purple'
}: CTAButtonProps) {
  const colors = variant === 'gold' ? 'bg-brand-goldBright text-brand-purpleDark ring-1 ring-brand-goldDark/30 hover:bg-brand-gold' : 'bg-brand-purple text-brand-goldLight ring-1 ring-brand-gold/50 hover:bg-brand-purpleDark';
  return <motion.a href="#pricing" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-flex items-center justify-center rounded-full px-8 py-4 text-lg font-bold shadow-[0_10px_24px_rgba(42,18,89,.22)] transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-goldBright/50 ${colors} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-255" data-mp="1t75l4ypzzi78">
      {children}
    </motion.a>;
}